/** @format */

import Filter from '../../../interfaces/forms/Filter';
import { RangeHelper } from './RangeHelper';

const _ = require('underscore');

export class FilterHelper {
    private props: any;

    private state: any;

    constructor(props: any, state: any) {
        this.props = props;
        this.state = state;
    }

    updateField = (fieldName: string, value: string | Array<number> | Array<string> | Array<boolean>): Array<Filter> | null => {
        const { filters } = this.props;
        const { rangeFlag } = this.state;
        const newFilter = new Array<Filter>();
        if (rangeFlag) {
            value = this.updateValueRange(value);
        }

        if (filters === null) {
            return null;
        }
        let eleFound = false;
        _.each(filters, (item: Filter): void => {
            if (item.name === fieldName) {
                eleFound = true;
                this.updateFiledObject(newFilter, fieldName, value);
            } else {
                newFilter.push(item);
            }
        });
        if (!eleFound) {
            this.updateFiledObject(newFilter, fieldName, value);
        }
        if (this.props.updateFilterList) {
            this.props.updateFilterList(newFilter);
        }
        return newFilter;
    };

    updateValueRange = (value: string | Array<number> | Array<string> | Array<boolean>): string | Array<number> | Array<string> | Array<boolean> => {
        if (typeof value === 'string') {
            const rangePrser = new RangeHelper();
            return rangePrser.parseValue(value);
        }
        return value;
    };

    updateFiledObject = (filter: Array<Filter>, fieldName: string, value: string | Array<number> | Array<string> | Array<boolean> | null): void => {
        if (value === null || value.length <= 0) {
            return;
        }
        filter.push({ name: fieldName, value: value });
    };
}
